import React from "react";
import { gql } from '@apollo/client';
import { Query } from "react-apollo";
import './postDetails.css';

const PostDetail: React.FC = () => {
  const slug = document.location.pathname.split('/').pop();
  const query = gql`query GetPostBySlug($slug: String!) {
  postBy(slug: $slug) {
    title
    date
    content
    featuredImage {
      node {
        sourceUrl
      }
    }
    author {
      node {
        name
      }
    }
  }
}`;
  const variables = {
    slug: slug
  }

  return (
    <div>
      <Query query={query} variables={variables}>
        {({ loading, error, data }) => {
          if (loading) return <div id="loading"><p>Loading...</p></div>;
          if (error) return <div id="error"><p>Error: {error.message}</p></div>;
          const when = new Date(data?.postBy?.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          });
          return (
            <div id="post-details">
              <h1>{data?.postBy?.title}</h1>
              <span className='small metadata'>{when} by {data?.postBy?.author?.node?.name}</span>
              <div dangerouslySetInnerHTML={{ __html: data?.postBy?.content }} />
            </div>
          );
        }}
      </Query>
    </div>);
};

export default PostDetail;